(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["codex-press-archive"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('.codex-press-contact-button');
    if (!button) return;

    var user = button.getAttribute('data-codex-mail-user');
    var domain = button.getAttribute('data-codex-mail-domain-a') + button.getAttribute('data-codex-mail-domain-b');
    var tld = button.getAttribute('data-codex-mail-tld');
    var subject = encodeURIComponent('Press inquiry');
    window.location.href = 'mailto:' + user + '@' + domain + '.' + tld + '?subject=' + subject;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eu-withdrawal-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const forms = document.querySelectorAll('[data-withdrawal-form]');
    forms.forEach((form) => {
      const section = form.closest('[data-withdrawal-section]');
      if (!section) return;

      const confirmPanel = section.querySelector('[data-withdrawal-confirm]');
      const status = section.querySelector('[data-withdrawal-status]');
      const editButton = section.querySelector('[data-withdrawal-edit]');
      const submitButton = section.querySelector('[data-withdrawal-submit]');
      const endpoint = form.getAttribute('data-endpoint');
      let payload = null;

      const setStatus = (message, state) => {
        status.textContent = message;
        status.dataset.state = state || '';
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const data = new FormData(form);
        payload = {
          fullName: String(data.get('fullName') || '').trim(),
          email: String(data.get('email') || '').trim(),
          orderReference: String(data.get('orderReference') || '').trim(),
          message: String(data.get('message') || '').trim(),
          website: String(data.get('website') || '').trim(),
          confirmed: false
        };

        if (!payload.fullName || !payload.email || !payload.orderReference) {
          setStatus('Please fill in name, email, and order reference.', 'error');
          return;
        }

        section.querySelector('[data-review-name]').textContent = payload.fullName;
        section.querySelector('[data-review-email]').textContent = payload.email;
        section.querySelector('[data-review-order]').textContent = payload.orderReference;
        form.hidden = true;
        confirmPanel.hidden = false;
        setStatus('', '');
      });

      editButton.addEventListener('click', () => {
        confirmPanel.hidden = true;
        form.hidden = false;
        setStatus('', '');
      });

      submitButton.addEventListener('click', async () => {
        if (!payload || !endpoint) return;
        payload.confirmed = true;
        submitButton.disabled = true;
        setStatus('Submitting...', '');

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          const result = await response.json();
          if (!response.ok || !result.ok) {
            throw new Error(result.message || 'The request could not be submitted.');
          }
          confirmPanel.hidden = true;
          setStatus(result.message || 'Your withdrawal request was submitted.', 'success');
        } catch (error) {
          setStatus(error.message || 'The request could not be submitted. Please contact shop@lucasestak.com.', 'error');
          submitButton.disabled = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
